import LeaveAttachment from './LeaveAttachment';

export default LeaveAttachment;
